module.exports = __webpack_public_path__ + "img/w3_circle_add_white.2196956c.png";